export default "__VITE_ASSET__CGlwQVxV__"